import { Box } from "@mui/joy";
import { ReactElement } from "react";
import { QuotesDataGrid } from "../hooks/quote/quotesDataGrid";
import { Paper } from "@mui/material";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function QuotesListRoute(): ReactElement {
  return (
    <Box sx={{ p: 2, width: "100%", height: "100%" }}>
      <Paper
        sx={{
          width: "100%",
          height: "calc(100vh - 146px)",
          display: "grid",
        }}
      >
        <QuotesDataGrid />
      </Paper>
    </Box>
  );
}
